import React from 'react';

const AlertBox = (props) => {
  const {
    renderItem, toggleAlert, removeCloseBtn, handleCloseDiscountInfo,
  } = props;

  const handleClose = () => {
    handleCloseDiscountInfo();
    toggleAlert();
  };

  return (
  <div className="alertBox">
    <div
      className="overlay"
      onClick={() => { if (!removeCloseBtn) { handleClose(); } }}
      role="button"
      tabIndex="0"
      style={{ outline: 'none' }}
    />
    <div className="innerBox">
      {!removeCloseBtn &&
        <div
          className="closeButton"
          onClick={() => handleClose()}
          role="button"
          tabIndex="0"
          style={{ outline: 'none' }}
        />}
      <div className="contentHolder">{renderItem(props)}</div>
    </div>
  </div>
  );
};

export default AlertBox;
